/* eslint-disable @nx/enforce-module-boundaries */
import { analiticaInstance } from 'shared/analitica'

const deviceFingerPrintEventsMetaData = {
  owner: 'Onboarding Safety',
  product: 'Device Fingerprint',
  project: 'Stone'
}

export const deviceFingerPrintEvents = analiticaInstance.eventFactory('Safety - Device Finger Print', {
  flowLogin: {
    generateToken: () => ({
      label: 'validation-status-changed',
      metadata: {
        ...deviceFingerPrintEventsMetaData,
        description: 'Evento disparado quando há geração do token da Incognia no fluxo v2',
        screen: 'Login',
        reference: 'Quando o usuário for se autenticar na plataforma'
      }
    }),
    error: (messageError: string) => ({
      label: 'validation-status-changed',
      metadata: {
        ...deviceFingerPrintEventsMetaData,
        description: messageError,
        screen: 'Login',
        reference: 'Quando o sdk da Incognia apresenta algum erro de inicialização'
      }
    })
  },
  home: {
    setAccountId: () => ({
      label: 'validation-status-changed',
      metadata: {
        ...deviceFingerPrintEventsMetaData,
        description:
          'Evento disparado quando o login foi efetuado e o usuário entra na home ou troca de conta no seletor de contas',
        screen: 'Home',
        reference: 'Assim que o usuário entra na home ou troca de conta no seletor de contas'
      }
    })
  }
})
